import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "12",
  viewBox: "0 0 22 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Group" }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M1 12V10H21V12H1ZM2.15 5.95L0.85 5.2L1.7 3.7H0V2.2H1.7L0.85 0.75L2.15 0L3 1.45L3.85 0L5.15 0.75L4.3 2.2H6V3.7H4.3L5.15 5.2L3.85 5.95L3 4.45L2.15 5.95ZM10.15 5.95L8.85 5.2L9.7 3.7H8V2.2H9.7L8.85 0.75L10.15 0L11 1.45L11.85 0L13.15 0.75L12.3 2.2H14V3.7H12.3L13.15 5.2L11.85 5.95L11 4.45L10.15 5.95ZM18.15 5.95L16.85 5.2L17.7 3.7H16V2.2H17.7L16.85 0.75L18.15 0L19 1.45L19.85 0L21.15 0.75L20.3 2.2H22V3.7H20.3L21.15 5.2L19.85 5.95L19 4.45L18.15 5.95Z",
        fill: "currentColor"
      })
    ], -1)
  ]))]))
}
export default { render: render }